<template></template>

<script>
export default {
    name: "sweet-alert",
    props: {
        title: String,
        text: String,
        type: {
            type: String,
            default: "success"
        }
    },
    methods: {
        showAlert() {
            this.$swal({
                title: this.title,
                text: this.text,
                type: this.type,
                confirmButtonColor: '#662C8A',
            });
        }
    },
    mounted() {
        this.showAlert();
    }
};
</script>
